/**
 * Minimál SSE-`data:`-parser egy fetch-Response body fölött — VENDOROZVA a `@morgens-design-kft/mo-client`-ből.
 * A Mo `/v1/ask` (a BFF `/mo/ask`-on át) `data: {json}` eventeket streamel; ez soronként kibontja a
 * JSON-payloadokat, kezelve a soktörős/pufferelt darabolást.
 */
export async function* parseSseData(body: ReadableStream<Uint8Array>): AsyncIterable<string> {
  const reader = body.getReader();
  const dec = new TextDecoder();
  let buf = '';
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let nl: number;
    while ((nl = buf.indexOf('\n')) !== -1) {
      const line = buf.slice(0, nl).trimEnd();
      buf = buf.slice(nl + 1);
      if (line.startsWith('data:')) {
        const payload = line.slice(5).trim();
        if (payload) yield payload;
      }
    }
  }
  const last = buf.trim();
  if (last.startsWith('data:')) {
    const payload = last.slice(5).trim();
    if (payload) yield payload;
  }
}
